import React, { useState } from "react";
import NavbarComponent from "../component/NavbarComponent";

const BookList = () => {
  const [classBook, setClassBook] = useState("one");

  return (
    <React.Fragment>
      <NavbarComponent />


      <div className="pl-20 pr-20">
        <div className="p-4 flex justify-center  items-center body-font ">
          <div className="grid grid-cols-8 justify-center items-center gap-5">
            <div
              onClick={() => {
                setClassBook("one");
              }}
              style={{
                backgroundColor: classBook === "one" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl  hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "one" ? "#fff" : "#000" }}
              >
                One
              </span>
            </div>
            <div
              onClick={() => {
                setClassBook("two");
              }}
              style={{
                backgroundColor: classBook === "two" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "two" ? "#fff" : "#000" }}
              >
                Two
              </span>
            </div>
            <div
              onClick={() => setClassBook("three")}
              style={{
                backgroundColor: classBook === "three" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{
                  color: classBook === "three" ? "#fff" : "#000",
                }}
              >
                Three
              </span>
            </div>
            <div
              onClick={() => {
                setClassBook("four");
              }}
              style={{
                backgroundColor: classBook === "four" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "four" ? "#fff" : "#000" }}
              >
                Four
              </span>
            </div>
            <div
              onClick={() => {
                setClassBook("five");
              }}
              style={{
                backgroundColor: classBook === "five" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "five" ? "#fff" : "#000" }}
              >
                Five
              </span>
            </div>
            <div
              onClick={() => setClassBook("six")}
              style={{
                backgroundColor: classBook === "six" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{
                  color: classBook === "six" ? "#fff" : "#000",
                }}
              >
                Six
              </span>
            </div>
            <div
              onClick={() => {
                setClassBook("seven");
              }}
              style={{
                backgroundColor: classBook === "seven" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "seven" ? "#fff" : "#000" }}
              >
                Seven
              </span>
            </div>
            <div
              onClick={() => {
                setClassBook("eight");
              }}
              style={{
                backgroundColor: classBook === "eight" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{ color: classBook === "eight" ? "#fff" : "#000" }}
              >
                Eight
              </span>
            </div>
            <div
              onClick={() => setClassBook("nine")}
              style={{
                backgroundColor: classBook === "nine" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{
                  color: classBook === "nine" ? "#fff" : "#000",
                }}
              >
                Nine
              </span>
            </div>
            <div
              onClick={() => setClassBook("ten")}
              style={{
                backgroundColor: classBook === "ten" ? "#43aee3" : "#f0ad4e",
              }}
              className="relative mx-1 px-8 py-2 group text-center rounded-lg shadow-xl hover:cursor-pointer duration-150  mb-1 md:mb-0"
            >
              <span
                className="firstlevel md:text-xl font-semibold whitespace-no-wrap  hover:text-gray-500"
                style={{
                  color: classBook === "ten" ? "#fff" : "#000",
                }}
              >
                Ten
              </span>
            </div>
          </div>
          {/* Nav  End */}
        </div>

        {classBook === "one" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class I
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S.No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marigold I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Marigold I)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Grammar In Action I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Pinnacle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Write Fluently Book I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sonka
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Rimjhim I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Abhyas Pustika(Rimjhim I)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Hindi Lekhan Abhyas I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Saphire
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Magic I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Explore Environment Studies
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vishal
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta Art & Craft
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Inspirations For Life
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marina
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Flamingo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "two" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class II
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marigold II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Marigold II)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Grammar In Action II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Pinnacle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Write Fluently Book II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sonka
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Rimjhim II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Abhyas Pustika(Rimjhim II)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Hindi Lekhan Abhyas II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Saphire
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Magic II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Explore Environment Studies
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vishal
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta Art & Craft
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Inspirations For Life
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marina
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Flamingo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "three" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class III
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marigold III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Marigold III)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Grammar In Action III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Pinnacle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Write Fluently Book III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sonka
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Rimjhim III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Abhyas Pustika(Rimjhim III)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Hindi Lekhan Abhyas III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Saphire
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Magic III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Looking Around I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta Art & Craft
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Inspirations For Life
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marina
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Flamingo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "four" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class IV
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3">S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marigold IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Marigold IV)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Grammar In Action IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Pinnacle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Write Fluently Book IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sonka
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Rimjhim IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Abhyas Pustika(Rimjhim IV)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Hindi Lekhan Abhyas IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Saphire
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Magic IV
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Looking Around II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta Art & Craft
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Inspirations For Life
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marina
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Flamingo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "five" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class V
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marigold V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Marigold V)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Grammar In Action V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Pinnacle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Write Fluently Book V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sonka
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Rimjhim V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Abhyas Pustika(Rimjhim V)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Hindi Lekhan Abhyas V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Saphire
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Magic V
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Looking Around III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta Art & Craft
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Vedanta
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Inspirations For Life
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Marina
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Flamingo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "six" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class VI
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Honeysuckle
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book (Honeysuckle)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      A Pact With the Sum
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Basant I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Balram Katha
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Adhunik Hindi Viyakaran Rachna
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Bharti Bhawan
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths VI
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Science VI
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Social and Political Life I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Our Habitat-Geography
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Our Past I – History
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Ruchira I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      13
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge VI
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      ND
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      14
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      School Atlas
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Oxford
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      15
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      English Grammar (Wren & Martin)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      S.Chand
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "seven" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class VII
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Honeydew for VII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book of Honeydew
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      An Alien Hand
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Basant II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Bal Mahabharat
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Adhunik Hindi Viyakaran Rachna
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Bharti Bhawan
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths VII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Science VII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Social and Political Life II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Our Habitat-Geography
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Our Past II History
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Ruchira II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      13
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge VII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      ND
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      14
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      School Atlas
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Oxford
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      15
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      English Grammar (Wren & Martin)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      S.Chand
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "eight" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class VIII
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Honeydew for VIII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Work Book of Honeydew
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      APC
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      It So Happened
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Basant III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Bharat ki Khoj
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Adhunik Hindi Viyakaran Rachna
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Bharti Bhawan
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths VIII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Science VIII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Social and Political Life III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Resources and Development-Geo
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Our Past II History
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Ruchira III
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      13
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      General Knowledge VII
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      ND
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      14
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      School Atlas
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Oxford
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      15
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      English Grammar (Wren & Martin)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      S.Chand
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      No Change
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : classBook === "nine" ? (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class IX
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      English Literature-BEEHIVE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      English Literature supplementary Book-MOMENTS
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Kshitiz I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Kritika I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Shiksharthi Hindi Viyakaran
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Science IX
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Practical Manual in S & T
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Natraj
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths IX
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Lab Manual
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Natraj
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      India and Contemporary World
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Democratic Politics I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Economics I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      13
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Contemporary India I
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      ND
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      14
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Disaster Management (Together)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      15
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sanskrit-“Manika Part I”
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                     CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      16
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Sanskrit Grammar-“ABHYASVAN BHAV-PRATHAM BHAG”
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      17
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Gulliver’s Travels : Jonthan Swift
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Any
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="py-4 mt-4 mb-2 ml-20 mr-20 col-span-3">
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
                Class X
              </div>
              <table className="min-w-full border text-center">
                <thead className="border-b ">
                  <tr className="bg-gray-100">
                    <th className="py-3"> S. No.</th>
                    <th className="py-3"> Name of Books</th>
                    <th className="py-3">Publishers</th>
                    <th className="py-3">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      01
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Interact In English Literature X (Revised Edition)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      02
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Interact In English MCB X (Revised Edition)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      03
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Interact In English WB X (Revised Edition)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      04
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Kshitiz II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      05
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Kritika II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      06
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Shiksharthi Hindi Viyakaran
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      07
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Science X
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      08
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Practical Manual in S & T
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Natraj
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      09
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths X
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      10
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Maths Lab Manual
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Natraj
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      11
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      India and Contemporary World
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      12
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Democratic Politics II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      13
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Economics II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      ND
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      14
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Contemporary India II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      NCERT
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      15
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Disaster Management (Together)
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      16
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Manika Bhag II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b ">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      17
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Manika Abhyas Pushtika Bhag II
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      CBSE
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                  <tr className="border-b bg-gray-100">
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      18
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      The Story of My Life – Helen Keller
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Any
                    </td>
                    <td className="py-3  text-sm font-medium text-gray-900 border-r">
                      Change As Per Latest CBSE circular
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default BookList;
